
import { Localization } from "@viamap/viamap2-common";
import { useState } from 'react';
import { ADModalBodyNoScroll, ADModalFooter, ADModalInfo, AdvancedDragModal } from 'src/componentsUtils/AdvancedDragModal';
import { GlassButton, GlassButtonRow } from './GlassButtons';
import { message } from './Message';
import { ManagedWindow } from "src/WindowManager/WindowState";

type Props = {
    managedWindow: ManagedWindow;
    url: string;
    embedCode: string;
    expireDate?: Date;
    callbackOnCancel: () => void;
};

export function ReadOnlyMapDialog(props: Props) {
    const [showEmbedCode, setShowEmbedCode] = useState(false)

    function handleClose(e: any) {
        // hide this window
        e?.preventDefault();
        props.callbackOnCancel();
    }

    function handleCopyToClipboard() {
        /* Get the text field */
        let copyText = document.getElementById("mit-url-text-area") as HTMLDivElement;

        if (copyText) {
            navigator.clipboard.writeText(copyText.innerText).then(() => {
                message.info("Copied to clipboard")
            });


        } else {
            //                alert("Field not found");
        }
    }

    function handleShowEmbedCode(showEmbedCode: boolean) {
        setShowEmbedCode(showEmbedCode)
    }

    const copytoclipboardbutton = <GlassButton onClick={() => handleCopyToClipboard()}>{Localization.getText("Copy to Clipboard")}</GlassButton>;
    return (
        <AdvancedDragModal
            window={props.managedWindow}
            PosDefault={{ top: "20%", left: "50%", width: "460px", transform: "translateX(-50%)" }}
            title={Localization.getText("Readonly Link has been Saved")}
            onClose={handleClose}
        >
            <ADModalInfo>
                {Localization.getText("Expires")} {props?.expireDate?.toLocaleDateString() || "ukendt"}
            </ADModalInfo>
            <ADModalBodyNoScroll templateRows={"5% 1fr 5%"}>
                <div />
                <div style={{ marginTop: "20px" }} >
                    <GlassButtonRow>
                        <GlassButton
                            className={showEmbedCode ? "EmbedCodebutton" : "EmbedCodeActive"}
                            onClick={() => { handleShowEmbedCode(false); }}

                        >
                            Link
                        </GlassButton>
                        <GlassButton
                            className={showEmbedCode ? "EmbedCodeActive" : "EmbedCodebutton"}
                            onClick={() => { handleShowEmbedCode(true); }}

                        >
                            Embed Code
                        </GlassButton>
                    </GlassButtonRow>
                    <div id="mit-url-text-area" className='EmbedCode'>{showEmbedCode ? props.embedCode : props.url}</div>
                </div>
            </ADModalBodyNoScroll>
            <ADModalFooter>
                {copytoclipboardbutton}
            </ADModalFooter>
        </AdvancedDragModal>)
}

export function SavedMapDialog(props: { managedWindow: ManagedWindow, refLink, callbackOnCancel, expireDate }) {
    const [call] = useState(location.origin + location.pathname)

    return (<ReadOnlyMapDialog
        managedWindow={props.managedWindow}
        url={call + "?mapdef=" + props.refLink}
        embedCode={"<iframe src=\"" + call + "?mapdef=" + props.refLink + "&embeddedmode=true\" width=\"350\" height=\"300\"></iframe>"}
        expireDate={props.expireDate}
        callbackOnCancel={props.callbackOnCancel} />)
}